import fp from 'lodash/fp';
import { configurations } from './configurations';

export const apiActions = {
  task: {
  }
}

const actions = {
  task: {
    api: {
      ...fp.reduce(
        (prev, { name, action: { task: { api } } }) => ({
          ...prev,
          [name]: api[name]
        }),
        {}
      )(configurations)
    },
    ...fp.reduce(
      (prev, { name, action: { task } }) => ({
        ...prev,
        [name]: task[name]
      }),
      {}
    )(configurations)
  }
};

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/task/actions.js